import { Button, Form, Input } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import imgC1 from "../../assets/images/imgC1.png";
import Banner from "../../components/Banner/Banner";
import contactWebService from "../../services/webService/ContactWebService";
import "./Contact.scss";
import imageBanner from "../../assets/images/banner.png"

const Contact = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("company", values.company);
            formData.append("mobile", values.mobile);
            formData.append("email", values.email);
            formData.append("title", values.title);
            formData.append("content", values.content);

            const data = await contactWebService.createContact(formData);

            if (data?.status === 200) {
                form.resetFields();
                toast.success(data?.message);
                setLoading(false);
            } else {
                toast.warn(data?.message);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error.message);
        }
    };
    return (
        <div className="section-top">
            <div className="container">
                <Banner
                    img={imgC1}
                    bgr={imageBanner}
                >
                    <h2 className="fs-1 fw-bold">Chào mừng bạn đến với HPay</h2>
                    <div className="my-3">
                        <p className="fs-6">Địa chỉ: Số A7 Lô A, Khu 5.2 ha, dự án nhà ở cho cán bộ cao cấp và cán bộ của Ban Đảng Trung Ương, Phường Yên Hòa, Thành phố Hà Nội, Việt Nam</p>
                        <p className="mt-3 fs-6">Điện thoại: 1900 0128</p>
                        <p className="mt-3 fs-6">Địa chỉ email: support@hpay.com.vn</p>
                    </div>
                    <Link to={"/tra-cuu-yeu-cau-ho-tro"} className="button-link">
                        Tra cứu yêu cầu hỗ trợ
                    </Link>
                </Banner>
                <div className="section-top-big">
                    <h2 className="text-center fw-bold fs-1 mb-4">Liên hệ</h2>
                    <div className="d-flex justify-content-center">
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            variant="filled"
                            className="form-contact"
                            size="large"
                            initialValues={{
                                name: "",
                                company: "",
                                mobile: "",
                                email: "",
                                title: "",
                                content: "",
                            }}
                        >
                            <Form.Item
                                name="name"
                                rules={[
                                    { required: true, message: "Vui lòng điền tên" },
                                    { max: 50, message: "Tên không được quá 50 ký tự" }
                                ]}
                            >
                                <Input placeholder="Họ và tên" />
                            </Form.Item>

                            <Form.Item
                                name="company"
                                rules={[
                                    { max: 50, message: "Tên công ty không được quá 50 ký tự" }
                                ]}
                            >
                                <Input placeholder="Công ty" />
                            </Form.Item>

                            <Form.Item
                                name="mobile"
                                rules={[
                                    { required: true, message: "Vui lòng điền số điện thoại" },
                                    { pattern: /^[0-9]{10,11}$/, message: "Số điện thoại không hợp lệ (chỉ nhận 10-11 chữ số)" },
                                ]}
                            >
                                <Input placeholder="Số điện thoại" />
                            </Form.Item>

                            <Form.Item
                                name="email"
                                rules={[
                                    { required: true, message: "Vui lòng điền Email" },
                                    { type: "email", message: "Địa chỉ email không hợp lệ" },
                                ]}
                            >
                                <Input placeholder="Địa chỉ email" />
                            </Form.Item>

                            <Form.Item
                                name="title"
                                rules={[
                                    { required: true, message: "Vui lòng điền tiêu đề" },
                                    { max: 255, message: "Tiều đề không được quá 255 ký tự" }
                                ]}
                            >
                                <Input placeholder="Tiêu đề" />
                            </Form.Item>

                            <Form.Item
                                name="content"
                                rules={[{ required: true, message: "Vui lòng điền nội dung" }]}
                            >
                                <Input.TextArea rows={5} placeholder="Nội dung..." />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="w-100" loading={loading}>
                                    Gửi
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
